import style from "../../../../assets/scss/common/modal/addConsultationModal.module.scss";
import React from "react";
import {useTranslation} from "react-i18next";

interface Args{
    subText?: string;
}
export function ReservationTitle({subText}:Args) {
    /**
     * 상담 신청하기 ~ 상담 정보를 확인해주세요.
     */
    const { t } = useTranslation("consultant");
    return (
        <>
            <h3 className={style.addChildInfoTitle}>{t('detail.modal.apply')}</h3>
            <div className={style.addChildInfoDesc}>
                <span className={style.boldDesc}>{t('detail.modal.desc')}</span>
                <br/>
                {subText}
            </div>
        </>
    )
}